import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store, { errors } from './store'

const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)

import 'vue2-animate/dist/vue2-animate.min.css'

import YDUI from 'vue-ydui'
import 'vue-ydui/dist/ydui.px.css'
Vue.use(YDUI)

import {InfiniteScroll} from 'vue-ydui/dist/lib.px/infinitescroll';
Vue.component(InfiniteScroll.name, InfiniteScroll);

import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
Vue.component('v-icon', Icon)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import Validator from './validator'
Vue.use(Validator)

import './axios'
import './app.less'

Vue.config.productionTip = false

Vue.config.errorHandler = Vue.prototype.$errorHandle = function (err, vm) {
  vm = vm || this
  switch (err) {
    case errors.notLogin:
      vm.$dialog.alert({
        mes: err.message,
        callback: () => {
          window.gotoLogin()
        }
      })
      return
  }
  throw err
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
